import { t } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/_forms/bedarfsermittlung')({
  component: RouteComponent,

  loader: () => ({
    breadcrumb: {
      label: t`Bedarfsermittlungen`,
      to: '/patienten/$id/bedarfsermittlungen',
      params: { id: 'patientId' },
    },
  }),
})

function RouteComponent() {
  return <Outlet />
}
